/*
Copyright 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

.visual-list {
  display: flex;
  flex-direction: column;
  gap: var(--cpd-space-1x);
  margin: 0;
  padding: 0;
  list-style-type: "";
  border-radius: var(--cpd-space-3x);
  overflow: hidden;
}

@media (forced-colors: active) {
  .visual-list {
    outline: 1px solid transparent;
  }
}
